<div class="bookingWindow greyBox buttonPointer" (click)="initBookingOption(0)">
    <div class="bookingWindowText">
        {{ bookingWindows[0].date == null ? 'Booking Window One' : (bookingWindows[0].date | date: 'dd  /  MM  /  yyyy') + ' ' + bookingWindows[0].time.from }}
    </div>
    <div class="bookingWindowIcon"><img
        src="assets/img/{{ clientID }}/icons/calendar.png" /></div>
    <div style="clear: both;"></div>
</div>

<div class="bookingWindow greyBox buttonPointer" (click)="initBookingOption(1)">
    <div class="bookingWindowText">
        {{ bookingWindows[1].date == null ? 'Booking Window Two' : (bookingWindows[1].date | date: 'dd  /  MM  /  yyyy') + ' ' + bookingWindows[1].time.from }}
    </div>
    <div class="bookingWindowIcon"><img
        src="assets/img/{{ clientID }}/icons/calendar.png" /></div>
    <div style="clear: both;"></div>
</div>

<div class="outOfHoursDisclaimer" *ngIf="outOfHoursEnabled">
    * Highlighted dates and times will be charged at an out of hours rate.
    <div>** This date is a preference only. Our team will be in touch to confirm your date.</div>
</div>